import React, {useContext, useEffect, useState} from "react";
import {Container, Row, Col} from "react-bootstrap";
import ContactUsIcon from "components/ContactUsIcon";
import AuthenticationService from "../service/AuthenticationService";
import {getSessionAttribute} from "../utils/SessionUtils";
import {LEGAL_ENTITY, LEGAL_ENTITY_TRADE_BREAKS} from "../utils/Constants";
import Component0330 from "./Component0330";
import Component0108 from "./Component0108";
import {HomepageContext} from "../pages/home/context";
import {EntityAccountsContext} from "../components/entity-accounts/context";
import {TradeBreakContext} from "../pages/tradecapture/context";

export default function AppFooter(props) {
    const baseurl = `${process.env.REACT_APP_FOOTER_PDF_PATH}`
    const [isLegalEntity, setIsLegalEntity] = useState(false);
    const {entityAccounts: entityAccountsHome} = useContext(HomepageContext);
    const {entityAccounts: entityAccountsOther} = useContext(EntityAccountsContext);
    const {curEntityAccounts: curEntityAccountsTradeBreaks} = useContext(TradeBreakContext);

    useEffect(() => {
        let tempLegalEntity = getSessionAttribute(LEGAL_ENTITY)??null
        setIsLegalEntity(tempLegalEntity === "0330"?true:false)
    },[entityAccountsHome, entityAccountsOther])

    useEffect(() => {
        let tempLegalEntity = getSessionAttribute(LEGAL_ENTITY_TRADE_BREAKS)
        setIsLegalEntity(tempLegalEntity === "0330"?true:false)
    },[curEntityAccountsTradeBreaks])

    return(<>
        <hr/>
        <footer className="td-bg-colour-7 pb-4">
            <Container fluid className="px-6">
                <Row>
                    {isLegalEntity? <Component0330 isLogin={props.isLogin} baseUrl={baseurl}/>:<Component0108 isLogin={props.isLogin} baseUrl={baseurl}/>}
                </Row>
            </Container>
            {!props.isLogin && !AuthenticationService.isInternalUser() && <ContactUsIcon/>}
        </footer>
    </>);
}